
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Testable from '@/mixins/Testable'
import V3Page from '@/components/V3Page.vue'
import { Panorama } from '@/models/Panorama'

@Component({
	components: { V3Page }
})
export default class SphereViewerDialog extends Mixins(Testable) {
	@Prop({ required: true })
	panorama!: Panorama

	@Prop({ required: false, default: 0 })
	startBearing!: number

	@Prop({ required: false, default: false })
	opened!: boolean
}
